import { Button, Modal } from "components";
import { Fragment, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { TbChevronRight } from "react-icons/tb";
import { useApi, useToggle } from "utils";
import { useCode, validationSchema, ValidationSchemaType } from "../utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormSection } from "./FormSection";
import toast from "react-hot-toast";

export function Create(props: {
    refetch: () => void
}) {
    const { isActive, toggle } = useToggle(false)
    return (
        <Fragment>
            <Button color="primary" onClick={toggle}>
                CREATE NEW <TbChevronRight />
            </Button>

            {isActive && <CreateModal toggle={toggle} refetch={props.refetch} />}
        </Fragment>
    )
}


function CreateModal(props: {
    toggle: () => void
    refetch: () => void
}) {
    const api = useApi()
    const { dataCode } = useCode()

    useEffect(() => {
        if (dataCode?.code) {
            methods.setValue("mr_group_code", dataCode?.code)
        }
    // eslint-disable-next-line
    }, [dataCode?.code])

    const methods = useForm<ValidationSchemaType>({
        resolver: yupResolver(validationSchema)
    })

    const onSubmit = (value: ValidationSchemaType) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/groupasset/add", value),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                props.toggle()
                props.refetch()
            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <Modal isOpen title="SETUP GROUP ASSET" size="xl" closeModal={props.toggle}>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <FormSection />
                    </Modal.Body>

                    <Modal.Footer className="text-end">
                        <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
                    </Modal.Footer>
                </form>
            </FormProvider>
        </Modal>
    )
}